import { createFileRoute } from "@tanstack/react-router";
import { PublicDocumentPage } from "../components/PublicDocumentPage";

export const Route = createFileRoute("/i/$token")({
  component: PublicInvoicePage,
});

function PublicInvoicePage() {
  const { token } = Route.useParams();
  return <PublicDocumentPage kind="invoice" token={token} />;
}
